import { render, staticRenderFns } from "./DaysOffManager.vue?vue&type=template&id=2260500a"
import script from "./DaysOffManager.vue?vue&type=script&lang=js"
export * from "./DaysOffManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports